import {indexWebsitePageDashboardUrl} from "../data/constants";

export const getCurrentWebsitePage = (currentWebsitePageUrl: any, websitePagesItems: any, currentWebsite:any) => {
    let currentWebsitePage = websitePagesItems.find((websitePage: any) =>
        (websitePage.url === currentWebsitePageUrl) && (websitePage.website === currentWebsite.id)
    );

    return currentWebsitePage;
};